// extracted by css-extract-rspack-plugin
export default {"currentPlanLabel":"n4Pc4Vh1MwcwXddD","dropdownMenu":"qcDtf5hivyYViQkj","commandPaletteShortcut":"oRliy2MyXcNWJzmW","commandPaletteShortcutKey":"JO7e8QkD75ccD8mb"};